import * as Ably from 'ably';
import { AblyProvider } from 'ably/react';
import { PropsWithChildren } from 'react';

const ablyKey = process.env.REACT_APP_ABLY_API_KEY;
const ablyClient = ablyKey ? new Ably.Realtime({ key: process.env.REACT_APP_ABLY_API_KEY }) : null;
const enableAbly = process.env.REACT_APP_USE_ABLY === 'true';

export const AblyWebsocketMainProvider = (props: PropsWithChildren) => {
  let { children } = props;

  if (!enableAbly || !ablyClient) {
    return (
      <AblyProvider client={new Ably.Realtime({ key: "" })}>
        {children}
      </AblyProvider>
    )
  }

  return (
    <AblyProvider client={ablyClient}>
      {children}
    </AblyProvider>
  );
}
